import React from "react";
import PropTypes from "prop-types";

export default function Client(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 0C5.0187 0 3 1.85614 3 4.13762C3 6.4191 5.0187 8.27524 7.5 8.27524C9.9813 8.27524 12 6.4191 12 4.13762C12 1.85614 9.9813 0 7.5 0Z"
        fill={props.fill}
      />
      <path
        d="M13.0989 10.9783C11.8669 9.82813 10.2336 9.19471 8.5 9.19471H6.5C4.7664 9.19471 3.13313 9.82813 1.90113 10.9783C0.675167 12.1229 0 14.9414 0 16.5403C0 16.7942 0.223867 17 0.5 17H14.5C14.7761 17 15 16.7942 15 16.5403C15 14.9414 14.3248 12.1229 13.0989 10.9783Z"
        fill={props.fill}
      />
    </svg>
  );
}

Client.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
Client.defaultProps = {
  className: "",
  fill: "#275ae7",
  width: 15,
  height: 17
};
